const STORAGE_KEY = 'fortune_seen_articles';
const COOKIE_KEY = 'fortune_seen_articles';
const COOKIE_MAX_AGE = 60 * 30;
const MAX_SEEN_ARTICLES = 100;

export function getSeenArticleIds(): string[] {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return [];
    }
    const parsed: unknown = JSON.parse(stored);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter((id): id is string => typeof id === 'string');
  } catch {
    return [];
  }
}

export function trackSeenArticle(articleId: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const ids = getSeenArticleIds();

    if (ids.includes(articleId)) {
      return;
    }

    ids.push(articleId);

    if (ids.length > MAX_SEEN_ARTICLES) {
      ids.splice(0, ids.length - MAX_SEEN_ARTICLES);
    }

    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // sessionStorage unavailable (private browsing, storage full, etc.)
  }
}

export function syncSeenArticlesToCookie(): void {
  if (typeof document === 'undefined') {
    return;
  }

  try {
    const ids = getSeenArticleIds();
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(JSON.stringify(ids))};path=/;max-age=${COOKIE_MAX_AGE};SameSite=Lax`;
  } catch {
    // cookie write failed
  }
}
